const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Matches a selected name with or without its legacy @ prefix. */
export const buildMentionRegex = (names) => {
  const escaped = (names || [])
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp);
  if (!escaped.length) return null;
  return new RegExp(`(?<!\\S)@?(${escaped.join("|")})(?!\\S)`, "g");
};

/** Finds the mention being typed immediately before the current caret. */
export const mentionAtCaret = (text, selectionStart) => {
  const end = Math.max(0, Math.min(selectionStart, text.length));
  const match = text.slice(0, end).match(/(?:^|\s)@([^\n@]*)$/);
  if (!match) return null;
  return {
    query: match[1].trim().toLowerCase(),
    start: match.index + match[0].lastIndexOf("@"),
    end,
  };
};

/**
 * Splits text into plain strings and { name } tag markers. Concatenating every
 * piece back reproduces the input exactly, which the input overlay depends on.
 */
export const splitMentions = (text, regex) => {
  if (!regex) return [text];
  const parts = [];
  let cursor = 0;
  for (const match of text.matchAll(new RegExp(regex))) {
    if (match.index > cursor) parts.push(text.slice(cursor, match.index));
    parts.push({ name: match[1], index: match.index });
    cursor = match.index + match[0].length;
  }
  parts.push(text.slice(cursor));
  return parts;
};

/** Last tag in the text, or null. The typed text is the source of truth. */
export const lastMention = (text, regex) => {
  if (!regex) return null;
  const found = [...text.matchAll(new RegExp(regex))];
  return found.length ? found[found.length - 1][1] : null;
};
